import { render } from "./InvestmentDetails.vue?vue&type=template&id=46db5de1"
import script from "./InvestmentDetails.vue?vue&type=script&lang=js"
export * from "./InvestmentDetails.vue?vue&type=script&lang=js"

import "./InvestmentDetails.vue?vue&type=style&index=0&id=46db5de1&lang=css"
script.render = render

export default script